import { isDefined, isEmpty } from '@hsp/utilities';

import { RoleOptions } from 'types/utilities';

/**
 * Determine if a user has the required permissions to access a page.
 * @param {RoleOptions} options Defines the roles the user is in and the required roles need to get access.
 * @returns {boolean} True if user has the required role, otherwise false.
 */
export const hasRole = ({ inRole = [], requiredRole = [] }: RoleOptions): boolean => {
  if (isEmpty(inRole) && isDefined(requiredRole)) {
    // user has no roles, but there are required roles present
    return false;
  }

  if (!isDefined(requiredRole) || isEmpty(requiredRole)) {
    // user has roles, but there aren't any defined required roles
    return true;
  }

  let inRoles: string[] = [];
  let requiredRoles: string[] = [];

  if (typeof inRole === 'string') {
    inRoles = [inRole];
  } else {
    inRoles = [...inRole];
  }

  if (typeof requiredRole === 'string') {
    requiredRoles = [requiredRole];
  } else {
    requiredRoles = [...requiredRole];
  }

  inRoles = inRoles.map((role) => role.toLowerCase());
  requiredRoles = requiredRoles.map((role) => role.toLowerCase());

  return requiredRoles.some((role) => inRoles.includes(role.toLowerCase()));
};
